import { Component, OnInit } from '@angular/core';
import { SocialAuthService, SocialUser, GoogleLoginProvider } from 'angularx-social-login';
import { AuthenticationService } from 'src/app/service/auth.service';
import swal from 'sweetalert2';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { PublicClientApplication, AuthenticationResult, BrowserAuthError } from '@azure/msal-browser';
import { Router } from '@angular/router';
import { MsalAuthService } from 'src/app/service/msal-auth.service';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';

@Component({
  selector: 'app-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss']
})
export class SocialLoginComponent extends ComponentBase implements OnInit {
  googleUser: SocialUser | null;
  microsoftUser: AuthenticationResult | null = null;

  constructor(
      private socialAuthService: SocialAuthService, 
      private msalAuthService: MsalAuthService, 
      private router: Router){
    super()
    this.googleUser = null;
    this.socialAuthService.authState.subscribe((user: SocialUser) => {
      this.googleUser = user;
    });
  }

  get hasGoogleLogin(): boolean {
    return this.attribute.attributes.some(attr => attr.key.toLowerCase() == "google")
  }

  get hasMicrosoftLogin(): boolean {
    return this.attribute.attributes.some(attr => attr.key.toLowerCase() == "microsoft")
  }

  get isLoggedOnMicrosoft(): boolean {
    return this.microsoftUser != null;
  }

  get isValid(): boolean {
    const requiredOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "required");

    if (requiredOpt && requiredOpt.value && requiredOpt.value.toLowerCase() == "true") {
      const loginObjects = this.attribute.attributes
        .filter(attr => attr.type.toLowerCase() == "object");

      return loginObjects.some(attr => 
        attr.attributes.some(a => 
          a.key.toLowerCase() == "auth data" && 
          a.attributes.some(b => 
            b.key.toLowerCase() == "code" && 
            b.value != null)));
    }

    return true;
  }

  ngOnInit() {
    this.saveAuthData();
  }

  private saveAuthData() {
    const microsoftObject = this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "object");

    if (microsoftObject && this.msalAuthService.getAuthCode() && this.checkViewMode('edit')) {
      const authData = microsoftObject.attributes
        .find(attr => attr.key.toLowerCase() == "auth data");

      if (authData) {
        const codeAttr = authData.attributes
          .find(attr => attr.key.toLowerCase() == "code");

        if (codeAttr) {
          codeAttr.value = this.msalAuthService.getAuthCode();
        }

        const codeVerifierAttr = authData.attributes
          .find(attr => attr.key.toLowerCase() == "code verifier");

        if (codeVerifierAttr) {
          codeVerifierAttr.value = this.msalAuthService.getCodeVerifier();
        }

        const accessTokenAttr = authData.attributes
          .find(attr => attr.key.toLowerCase() == "access token");

        if (accessTokenAttr) {
          accessTokenAttr.value = this.msalAuthService.getAccessToken();
        }

        this.emit({ name: "autosave", data: "silently" });
      }
    }
  }

  private getAttributeValue(parentKey: string, childKey: string): string {
    const parentAttr = this.attribute.attributes.find(
      (a) => a.key.toLowerCase() === parentKey.toLowerCase()
    );
  
    if (parentAttr && parentAttr.attributes) {
      const childAttr = parentAttr.attributes.find(
        (child) => child.key.toLowerCase() === childKey.toLowerCase()
      );
      return childAttr ? childAttr.value : '';
    }
  
    return '';
  }

  public getLoginOptions(): AttributeModel[] {
    return this.attribute.attributes
      .filter(attr => attr.type.toLowerCase() == "SocialLoginOption".toLowerCase())
  }

  public loginMicrosoft() {
    const clientId = this.getAttributeValue('microsoft', 'clientId');
    const tenantId = this.getAttributeValue('microsoft', 'tenantId');
    const scope = this.getAttributeValue('microsoft', 'scope');
    
    this.msalAuthService.setClientId(clientId);
    this.msalAuthService.setTenantId(tenantId);
    this.msalAuthService.setScope(scope);
    this.msalAuthService.setCurrentRoute(location.pathname);

    this.router.navigateByUrl('/azure-auth-callback');
  }

  public performGoogleLogin() {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID)
      .then((data: any) => {
        const domainOpt = this.attribute.options
          .find(opt => opt.key.toLowerCase() == "allowedDomains".toLowerCase());

        if(!domainOpt) {
          //this.sendTokenToBackend(this.googleUser.idToken)
          this.attribute.value = this.googleUser.email;
        } else {
          const allowedDomains = domainOpt.value.split(',').map(domain => domain.trim());
          const userEmailDomain = this.googleUser.email.split('@')[1];

          if (allowedDomains.includes(userEmailDomain)) {
            //this.sendTokenToBackend(this.googleUser.idToken);
            this.attribute.value = this.googleUser.email;
          } else {
            this.attribute.value = null;
            console.error('Acesso negado para o domínio do email:', userEmailDomain);
            swal.fire("Acesso negado", 
              allowedDomains.length > 1 
                ? `Somente os domínios ${domainOpt.value} são permitidos.`
                : `Somente o domínio ${domainOpt.value} é permitido.`);
            this.socialAuthService.signOut();
          }
        }
      }, (error) => {
        console.error('Erro ao tentar realizar a autenticação da Google.');
        this.attribute.value = null;
      });
  }

  public logoutGoogle() {
    this.socialAuthService.signOut();
  }

  public logoutMicrosoft() {
    this.msalAuthService.getMsalInstance().logoutRedirect({
      postLogoutRedirectUri: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',
    });
  }
}
